/* tslint:disable */
/* eslint-disable */
/**
 * DaaS
 * Data as a Service - website backend for frontend.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: maritime_support@gatehouse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  userId: string;
  /**
   * Your password must be between 10 and 30 characters
   *  Your password must contain at least one uppercase, or capital, letter
   *  Your password must contain at least one lowercase letter
   *  Your password must contain at least one number digit
   *  Your password must contain at least one special character
   * @type {string}
   * @memberof LoginRequest
   */
  password: string;
}

/**
 * Check if a given object implements the LoginRequest interface.
 */
export function instanceOfLoginRequest(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && 'userId' in value;
  isInstance = isInstance && 'password' in value;

  return isInstance;
}

export function LoginRequestFromJSON(json: any): LoginRequest {
  return LoginRequestFromJSONTyped(json, false);
}

export function LoginRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LoginRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    userId: json['user_id'],
    password: json['password'],
  };
}

export function LoginRequestToJSON(value?: LoginRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    user_id: value.userId,
    password: value.password,
  };
}
